import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TransliterateService {
    
  constructor(private http: HttpClient) {}

  getSuggestions(word: string, lang: string = 'te'): Observable<string[]> {
    const url = `https://inputtools.google.com/request?text=${encodeURIComponent(word)}&itc=${lang}-t-i0-und&num=5&cp=0&cs=1&ie=utf-8&oe=utf-8`;
    return this.http.get<any>(url).pipe(
      map(res => {
        // Google returns: [status, [[word, [suggestions]]]]
        if (res && res[1] && res[1][0] && res[1][0][1]) {
          return res[1][0][1];
        }
        return [];
      })
    );
  }

}
